// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ad8fc56657222a5dcca53cdb2822b4e36473ca4c/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};